import {useMemo, useState} from "react";
import {Stack, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {appStyles} from "../../../../AppStyles.ts";
import {StyledInputBase, StyledSearch, StyledSearchIconWrapper} from "../../../AppStyledComponents.tsx";
import type {ContentSeries} from "../../../../sdo/ContentSeries.ts";
import ContentFrameCard from "../../intel/panels/resources/ContentFrameCard.tsx";

// TODO: Replace with API call to AResourceProfileManager.readContentSeries()
function buildTestData(): ContentSeries {
    return {
        uid: "cs-1",
        pageCount: 6,
        frames: [
            {
                uid: "f1", frameNumber: 1,
                page: 1, section: 1, paragraph: 1, sentence: 1,
                originalText: "Executive summary of the quarterly threat landscape report.",
                pointers: [{uid: "p1", typeKey: "user_profile", display: "Analyst Alpha"}],
            },
            {
                uid: "f2", frameNumber: 2,
                page: 1, section: 1, paragraph: 2, sentence: 1,
                originalText: "Key findings indicate increased activity in target sectors.",
                pointers: [],
            },
            {
                uid: "f3", frameNumber: 3,
                page: 2, section: 1, paragraph: 1, sentence: 1,
                originalText: "Threat actor TTX-4412 was observed leveraging spear-phishing campaigns targeting financial institutions.",
                pointers: [{uid: "p2", typeKey: "campaign", display: "TTX-4412"}],
            },
            {
                uid: "f4", frameNumber: 4,
                page: 3, section: 2, paragraph: 1, sentence: 3,
                originalText: "Cross-reference confirmed via DNS log correlation on segment 192.168.4.0/24.",
                pointers: [
                    {uid: "p3", typeKey: "user_profile", display: "Subject A"},
                    {uid: "p4", typeKey: "location", display: "Data Center East"},
                ],
            },
            {
                uid: "f5", frameNumber: 5,
                page: 4, section: 1, paragraph: 3, sentence: 2,
                originalText: "Secondary analysis supports the initial attribution with moderate confidence.",
                pointers: [],
            },
            {
                uid: "f6", frameNumber: 6,
                page: 5, section: 1, paragraph: 1, sentence: 1,
                originalText: "Appendix A: full timeline of observed events.",
                pointers: [],
            },
        ],
    };
}

function UXResourceSeriesPanel() {
    const [contentSeries] = useState<ContentSeries>(buildTestData);
    const [filterText, setFilterText] = useState("");

    const filtered = useMemo(() => {
        if (!filterText.trim()) return contentSeries.frames;
        const q = filterText.toLowerCase();
        return contentSeries.frames.filter((f) =>
            f.originalText.toLowerCase().includes(q)
        );
    }, [contentSeries, filterText]);

    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            {/* Title */}
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Content Frames</Typography>
            </Stack>

            {/* Filter bar */}
            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center">
                <StyledSearch>
                    <StyledSearchIconWrapper>
                        <SearchIcon sx={{fontSize: 16, color: "#7093a0"}}/>
                    </StyledSearchIconWrapper>
                    <StyledInputBase
                        placeholder="Filter by content..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                    />
                </StyledSearch>
                <Typography sx={appStyles.panelFilterCount}>
                    Showing {filtered.length} of {contentSeries.frames.length}
                </Typography>
            </Stack>

            {/* Frame card list */}
            <Stack direction="column" spacing={1} sx={{...appStyles.defaultPanelCardsWrapper, padding: "8px", alignItems: "stretch"}}>
                {filtered.map((frame) => (
                    <ContentFrameCard key={frame.uid} frame={frame}/>
                ))}
                {filtered.length === 0 && (
                    <Typography sx={{
                        color: "rgba(242, 245, 250, 0.4)",
                        fontSize: "0.80rem",
                        textAlign: "center",
                        padding: "24px",
                    }}>
                        No content frames match the current filter
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
}

export default UXResourceSeriesPanel;
